import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";

export const RemovableArtist = (props: RemovableProps<server.dto.ArtistSmall>) => {

  return <RemovableLabel
    {...props}
  >
    <CompanySidePanel type="artist"
      companyId={props.value.artistId}
      trigger={<a>
        {props.value.name}
      </a>}
    />
  </RemovableLabel>;
};